/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { Button, Grid } from '@material-ui/core';
import { Add, Replay } from '@material-ui/icons';
import { useDispatch, useSelector } from 'react-redux';
import { useEditingProfileId } from '../../../../hooks/useEditingProfile';

import DoanhNghiepInsert from '../DoanhNghiepInsert';
import { techCompanyActions, formActions } from '../../../../actions';
import { CATEGORY } from '../../../../constants/enums';

export default function DoanhNghiepButton(props) {
  const dispatch = useDispatch();
  const profileId = useEditingProfileId();
  const openSeasonId = useSelector(state => state.seasonReducer.openSeasonId);
  const totalTechCompanyList = useSelector(state => state.techCompanyReducer.totalTechCompanyList);
  const personalTechCompanyList = useSelector(state => state.techCompanyReducer?.personalTechCompanyList);

  const [inserting, setInserting] = useState(false);

  const handleClick = () => setInserting(true);
  const handleClose = () => setInserting(false);
  const handleReload = () => {
    if (props.filterType === 'person') {
      // CHỈ season đang mở - không dùng getTechCompanysByProfileId (lấy hết
      // mọi season ứng viên từng đăng ký, gây lẫn dữ liệu giữa các mùa giải).
      dispatch(formActions.reloadSeasonAchievements(profileId, openSeasonId, CATEGORY.QCV));
    } else {
      dispatch(techCompanyActions.getAllTechCompany());
    }
  }

  useEffect(() => {
    // Phải chờ openSeasonId có giá trị mới gọi - nếu profileId load xong
    // TRƯỚC openSeasonId (2 API độc lập, không đảm bảo thứ tự), gọi với
    // seasonId=null sẽ khiến backend bỏ qua điều kiện lọc season, trả về
    // TẤT CẢ hồ sơ của ứng viên qua mọi mùa giải -> lẫn dữ liệu season khác.
    if (
      props.filterType === 'person' &&
      !isNaN(profileId) &&
      openSeasonId &&
      !isNaN(openSeasonId) &&
      personalTechCompanyList.length === 0
    ) handleReload();
  }, [profileId, openSeasonId]);

  useEffect(() => {
    if (props.filterType === 'all' && totalTechCompanyList.length === 0) handleReload();
  }, []);

  return (
    <>
      <Grid item xs={12} md={3}>
        <div style={{ float: 'right' }}>
          <Button variant='outlined' startIcon={<Replay />} style={{ backgroundColor: 'white', marginRight: 8 }} onClick={handleReload} >Tải lại</Button>
          {props.filterType === 'person' && (
            <Button variant='contained' color='secondary' startIcon={<Add />} onClick={handleClick}>Thêm</Button>
          )}
        </div>
      </Grid>


      <DoanhNghiepInsert open={inserting} onClose={handleClose} />
    </>
  );
}
